export default __webpack_public_path__ + "static/media/Warlord's Scepter.970d3626.jpg";